import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@plantus/tema/tema.css";
import "@plantus/ui/ui.css";
import "./app.css";

import { App } from "./App";

const raiz = document.getElementById("raiz");
if (raiz === null) {
  throw new Error("elemento #raiz não encontrado");
}

createRoot(raiz).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
